<p-dialog modal="true" styleClass="atlas-dialog-s" position="middle" [closable]="allowClose" [(visible)]="show">
  <ng-template pTemplate="header">
    <h4>
      {{ required ? ('shared.container.top-nav.password-reset.header-required' | translate | titlecase) : '' }}
    </h4>
  </ng-template>
  <div *ngIf="required" class="mb-15">
    <p>
      {{ 'shared.container.top-nav.password-reset.body-required-1' | translate }}
      <a href="https://google.com" target="_blank">{{ 'common.learn-more' | translate | ucfirst }}</a
      >.
    </p>
    <p>
      {{ 'shared.container.top-nav.password-reset.body-required-2' | translate }}
    </p>
  </div>
  <form #resetForm="ngForm">
    <div  class="mb-15 mct-flex mct-col">
      <label>{{ 'shared.container.top-nav.password-reset.enter-password' | translate | ucfirst }}</label>
      <p-password
        name="pass1"
        [(ngModel)]="password1"
        [required]="true"
        autocomplete="off"
        class="atlas-password"
        mediumRegex="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d]).{8,}$"
        strongRegex="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d]).{12,}$"
        (change)="validatePassword()"
        [inputStyleClass]="isPasswordValid ? 'ng-valid' : 'ng-invalid'"
        appendTo="body"
      >
        <ng-template #header pTemplate="header">
          <div class="f-wb mb-4">Pick a password</div>
        </ng-template>
        <ng-template #footer pTemplate="footer">
          <p-divider />
          <div>
            <ul style="margin-left: -15px">
              <li>At least one lowercase</li>
              <li>At least one uppercase</li>
              <li>At least one number</li>
              <li>At least one symbol</li>
              <li>Minimum 8 characters</li>
            </ul>
          </div>
        </ng-template>
      </p-password>
    </div>
    <div class="mct-flex mct-col" >
      <label>{{ 'shared.container.top-nav.password-reset.confirm-password' | translate | ucfirst }}</label>
      <p-password
        name="pass2"
        [(ngModel)]="password2"
        [required]="true"
        autocomplete="off"
        class="atlas-password"
        mediumRegex="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d]).{8,}$"
        strongRegex="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d]).{12,}$"
        (change)="validatePassword()"
        [inputStyleClass]="isPasswordValid ? 'ng-valid' : 'ng-invalid'"
        appendTo="body"
      >
        <ng-template #header pTemplate="header">
          <div class="f-wb mb-4">Pick a password</div>
        </ng-template>
        <ng-template #footer pTemplate="footer">
          <p-divider />
          <div>
            <ul style="margin-left: -15px">
              <li>At least one lowercase</li>
              <li>At least one uppercase</li>
              <li>At least one number</li>
              <li>At least one symbol</li>
              <li>Minimum 8 characters</li>
            </ul>
          </div>
        </ng-template>
      </p-password>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <div class="alert alert-danger t-al mct-flex mct-col mct-gap-15" [hidden]="passwordIssues.length == 0"  >
      <div *ngFor="let issue of passwordIssues">
        {{ issue }}
      </div>
    </div>
    <div class="w-100">
      <button
        class="atlas-btn atlas-btn-primary w-100"
        [disabled]="!resetForm.valid || passwordIssues.length > 0 || isSaving"
        (click)="save()"
      >
        <wl-busy [show]="isSaving"></wl-busy>
        <span [hidden]="isSaving">{{ 'common.ok' | translate | uppercase }}</span>
        <span [hidden]="!isSaving">{{ 'common.saving' | translate | uppercase }}</span>
      </button>
    </div>
  </ng-template>
</p-dialog>
